module.exports = __webpack_public_path__ + "static/media/smileRating1.4cc79289.svg";